// What's pasted or shared to Tripmo as a link (SaveLink.tsx, ShareLink.tsx). Plain, so the unit tests read it.

// A link as typed or shared, made whole ("expedia.com/x" is https://expedia.com/x), or null when it isn't one: the
// first link in what was shared, when it's words with a link in them.
export function linkIn(text: string | null | undefined): string | null {
  const t = text?.trim();
  if (!t) return null;
  const found = t.match(/https?:\/\/[^\s<>"]+/i)?.[0]?.replace(/[).,;!?'"]+$/, "") ?? (/\s/.test(t) ? null : t);
  if (!found) return null;
  try {
    const url = new URL(/^https?:\/\//i.test(found) ? found : `https://${found}`);
    if (!/^https?:$/.test(url.protocol) || !url.hostname.includes(".")) return null;
    return url.href.length <= 2000 ? url.href : null;
  } catch {
    return null;
  }
}
